export default __webpack_public_path__ + "static/media/jm.85990944.svg";